import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../api";
import { useAuth } from "../context/AuthContext";
import { toast } from "../hooks/use-toast";
import AuthLayout from "../components/AuthLayout";
import { Loader2 } from "lucide-react";

export default function ArtistClaim() {
  const { token } = useParams();
  const { reload } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get(`/artist/claim/${token}`)
      .then(({ data }) => setInfo(data))
      .catch((e) => setError(e?.response?.data?.detail || "This invite link is invalid or expired"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/artist/claim", { token, password, name: info?.name });
      localStorage.setItem("gp_token", data.token);
      await reload();
      toast({ title: "Welcome!", description: "Your artist profile is now yours to manage." });
      nav("/artist");
    } catch (err) {
      toast({ title: "Could not claim profile", description: err?.response?.data?.detail || "Please try again", variant: "destructive" });
    } finally { setLoading(false); }
  };

  if (error) return (
    <AuthLayout title="Invite link" subtitle="">
      <p className="text-[#c0392b]" data-testid="claim-error">{error}</p>
      <p className="text-sm text-[#5a6b80] mt-4"><Link to="/login" className="text-[#1fb0b0] font-medium hover:underline">Go to sign in</Link></p>
    </AuthLayout>
  );
  if (!info) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#2ec9c9]" size={36} /></div>;

  return (
    <AuthLayout title={`Claim your profile, ${info.name}`} subtitle="Set a password to manage your bio, fee and booking enquiries.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-[#16243b] mb-1.5">Email</label>
          <input type="email" value={info.email} disabled className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-[#5a6b80]" />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#16243b] mb-1.5">Choose a password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="claim-password"
            className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" placeholder="••••••••" />
        </div>
        <button disabled={loading} data-testid="claim-submit" className="gp-btn-teal w-full rounded-xl py-3 font-medium disabled:opacity-60">
          {loading ? "Setting up…" : "Claim my profile"}
        </button>
      </form>
    </AuthLayout>
  );
}
